import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Configurations/store";
import { FEATURE_WORKFLOW_DOC_GROUPS } from "./Configurations/FeatureFlags";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./Themes/theme";

// Initialize Sentry error tracking
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV || "development",
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  beforeSend(event) {
    if (window.location.hostname === "localhost") return null;
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Phase 0: log feature flag state at startup (no functional changes)
// eslint-disable-next-line no-console
console.log(
  "FEATURE_WORKFLOW_DOC_GROUPS=",
  FEATURE_WORKFLOW_DOC_GROUPS
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
